import {defineMessages} from 'react-intl';

export const BrandDriverMessages = defineMessages({
  'sell-quickly_title': {
    id: 'BrandDriver.QuickAndEasy.Title',
    defaultMessage: 'quick & easy'
  },
  'sell-quickly_msg': {
    id: 'BrandDriver.QuickAndEasy.Msg',
    defaultMessage: 'Sell event tickets from any device in a few steps'
  },
  'audience_title': {
    id: 'BrandDriver.Audience.Title',
    defaultMessage: 'massive audience'
  },
  'audience_msg': {
    id: 'BrandDriver.Audience.Msg',
    defaultMessage: 'Over 100 million fans buying 1.3 tickets per second on StubHub'
  },
  'secure_title': {
    id: 'BrandDriver.Security.Title',
    defaultMessage: 'secure'
  },
  'secure_msg': {
    id: 'BrandDriver.Security.Msg',
    defaultMessage: 'We\'ll help get your tickets to buyers wherever you are'
  },
  'payments_title': {
    id: 'BrandDriver.GetPaid.Title',
    defaultMessage: 'get paid'
  },
  'payments_msg': {
    id: 'BrandDriver.GetPaid.Msg',
    defaultMessage: 'Receive payment from StubHub directly'
  }
});


export const BrandDriverConfigs = {

  brandDrivers: [
    {
      name: 'sell-quickly',
      svgComponent: "SellQuicklySVG"
    },
    {
      name: 'audience',
      svgComponent: "AudienceSVG"
    },
    {
      name: 'secure',
      svgComponent: "SecuritySVG"
    },
    {
      name: 'payments',
      svgComponent: "PaymentsSVG"
    }
  ]
};
